// default
export const FETCHING = 'FETCHING'
// AUTHENTICATION CONSTANTS
export const SIGN_IN = 'SIGN_IN'
export const LOG_OUT = 'LOG_OUT'
export const SIGN_UP = 'SIGN_UP'
export const ON_ERROR = 'ON_ERROR'
export const ERROR_TXT = 'ERROR_TXT'
export const FETCH_CONTACT = 'FETCH_CONTACT'

